module.exports = __webpack_public_path__ + "img/mazda-approved-srp-preview.73a9c8a0.png";